import type { RouteObject } from "react-router";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";
import { OnboardingRouteLayout } from "@/src/onboarding/layouts/onboarding-route-layout";
import CreateCommunityPersonalizePage from "@/src/onboarding/pages/create-community-personalize-page";
import CreateCommunityProfilePage from "@/src/onboarding/pages/create-community-profile-page";
import JoinCommunityPage from "@/src/onboarding/pages/join-community-page";
import PendingJoinCommunityPage from "@/src/onboarding/pages/pending-join-community-page";
import ProfilePage from "@/src/onboarding/pages/profile-page";
import SelectCommunityPage from "@/src/onboarding/pages/select-community-page";

export const onboardingRoutes: RouteObject = {
	element: <OnboardingRouteLayout />,
	children: [
		{ path: ONBOARDING_ROUTES.ROOT, element: null },
		{ path: ONBOARDING_ROUTES.PROFILE, element: <ProfilePage /> },
		{ path: ONBOARDING_ROUTES.CREATE_COMMUNITY_PROFILE, element: <CreateCommunityProfilePage /> },
		{ path: ONBOARDING_ROUTES.CREATE_COMMUNITY_PERSONALIZE, element: <CreateCommunityPersonalizePage /> },
		{ path: ONBOARDING_ROUTES.JOIN_COMMUNITY, element: <JoinCommunityPage /> },
		{ path: ONBOARDING_ROUTES.PENDING_JOIN_COMMUNITY, element: <PendingJoinCommunityPage /> },
		{ path: ONBOARDING_ROUTES.SELECT_COMMUNITY, element: <SelectCommunityPage /> },
	],
};
